var map = {
	"./danger-logo.svg": "dc1a",
	"./door-left-logo.svg": "464f",
	"./ekool-logo.svg": "4fc0",
	"./eliis-logo.svg": "2b44",
	"./google-logo.svg": "6afe",
	"./letter-logo.svg": "7ed3",
	"./microsoft-logo.svg": "45d7",
	"./passkey-logo.svg": "f5c8",
	"./phone-logo.svg": "52cb",
	"./protected-logo.svg": "967c",
	"./sms-logo.svg": "5284"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "051c";